import { HttpContext } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import {
  FfdNotesInvitationJoinRequestResolveResponse,
  FfdNotesInvitationResolveDataService,
  FfdNotesInvitationResolveResponse,
} from '@ffd/api-client';
import { DISABLE_GLOBAL_ERROR_TOASTS } from '@libs/utils';
import { map, Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FfdNotesInvitationResolveService {
  private readonly resolveDataService = inject(FfdNotesInvitationResolveDataService);

  public readonly codeSignal = signal<string | null>(null);
  public readonly resolutionSignal = signal<FfdNotesInvitationResolveResponse | null>(null);
  public readonly joinRequestIdSignal = signal<string | null>(null);
  public readonly joinRequestResolutionSignal = signal<FfdNotesInvitationJoinRequestResolveResponse | null>(null);

  public setCode(code: string): void {
    this.codeSignal.set(code);
  }

  public resolveCode$(): Observable<FfdNotesInvitationResolveResponse> {
    return this.resolveDataService
      .resolveFfdNotesInvitation(this.codeSignal()!, undefined, undefined, undefined, {
        context: new HttpContext().set(DISABLE_GLOBAL_ERROR_TOASTS, true),
      })
      .pipe(
        map((r) => r as FfdNotesInvitationResolveResponse),
        tap((resolution) => this.resolutionSignal.set(resolution)),
      );
  }

  public resolveJoinRequest$(joinRequestId: string): Observable<FfdNotesInvitationJoinRequestResolveResponse> {
    this.joinRequestIdSignal.set(joinRequestId);

    return this.resolveDataService
      .resolveFfdNotesInvitation(undefined, joinRequestId, undefined, undefined, {
        context: new HttpContext().set(DISABLE_GLOBAL_ERROR_TOASTS, true),
      })
      .pipe(
        map((r) => r as FfdNotesInvitationJoinRequestResolveResponse),
        tap((resolution) => this.joinRequestResolutionSignal.set(resolution)),
      );
  }
}
